import { gql } from "@apollo/client"
//
// VAPOR2
//
/*
EXAMPLE:
{
    "userUUID":"reg1",
    "set":{
	"slug":"written-by-gql-ui",
	"uuid":"00000000-0000-0000-0000-000000000555",
	"userCount":1,
	"fbackUserCount":null,
	"weight":null,
	"weightSum":null,
	"weightNorm":null,
	"tags":[
	    "devshell",
	    "fback-set-tag"
	]
    },
    "issue":{
	"sentiment":"positive"
    },
    "statements":[
	{
	    "uuid":"00000000-0000-0000-0000-000000000333",
	    "slug":"us-votebymail-statement-1",
	    "rank":1
	},
	{
	    "uuid":"00000000-0000-0000-0000-000000000333",
	    "slug":"us-votebymail-statement-2",
	    "rank":2
	}
    ]
}
*/
const WRITE_FBACK_MUTATION=gql`
mutation WriteFbackMutation(
  $userUUID:ID!
  $userSlug:ID!
  $set:SetInputType
  $issue:IssueInputType
  $statements:[StatementInputType]
) {
  writeFback(
    userUUID:$userUUID
    userSlug:$userSlug
    set:$set
    issue:$issue
    statements:$statements
  )
}
`


/*
EXAMPLE:
{
    "userUUID":"reg1",
    "userEmail":"reg1@lightinig.live"
}
*/
const READ_USER_DATA_QUERY = gql`
query ReadUserDataQuery($userUUID: ID, $userSlug: ID, $userEmail: ID) {
  user(uuid: $userUUID, slug: $userSlug, email: $userEmail) {
    uuid
    slug
    name
    email
    loginLevel
    geo {
      nation {
        code
        name
      }
      county {
        name
      }
      uscd {
        code
      }
      ssd {
        code
      }
      address {
        uuid
        street
        state {
          code
          name
        }
        city {
          name
        }
        zip {
          code
          plus4
        }
      }
    }
    isLatest
    isActive
    isVerified
    contacts {
      uuid
      slug
      geo {
        nation {
          code
          name
        }
        county {
          name
        }
        uscd {
          code
        }
       ssd {
          code
        }
        address {
          state {
            name
            code
          }
          zip {
            code
            plus4
          }
        }
      }
      level
      position {
        name
        description
      }
      person {
        name
      }
      district {
        name
        description
      }
    }
    statements {
      timestamp
      txt
      rank
      slug
      uuid
      source
      tags
      set {
        slug
        uuid
        userCount
        tags
      }
      drive {
        slug
        uuid
        timestamp
      }
      issue {
        slug
        uuid
        txt
        level
      }
      user {
        uuid
        slug
        geo {
          uscd {
            code
          }
          state {
            code
          }
        }
      }
    }
  }
}
`

/*
EXAMPLE:
{
    "user": {
	"uuid": "gql-user-zip-94010",
	"name": "Gql User",
	"email": "gql14@lightning.live",	
	"loginLevel": "VERIFIED",
	"isActive": true,
	"isVerified": true,
	"geo": {
	    "city":{
		"name": "Hillsborough"
	    },
	    "county": {
		"name": "San Mateo County"
	    },
	    "state": {
		"code": "CA",
		"name": "California"
	    },
	    "uscd": {
		"code": "14"
	    },
	    "nation": {
		"code": "USA",
		"name": "United States Of America"
	    },
	    "address": {
		"uuid": "gql14-user-zip-address-94010",
		"street": "14th Street",
		"zip": {
		    "code": "94010",
		    "plus4": "6446"
		}
	    }
	}
    }
}
*/
const SET_USER_MUTATION = gql`
mutation SetUserMutation ($user:UserInputType!) {
  setUser(user: $user)
}
`


/*
EXAMPLE:
{
  "userUUID": "gql-user-zip-94010",
  "templateUUID": "template-new-user-zip-94010"
}
*/
const WRITE_POSTS_MUTATION = gql`
mutation WritePostsMutation ($userUUID: ID!, $templateUUID: ID!) {
  writePosts(
    userUUID: $userUUID,
    templateUUID: $templateUUID
  )
}
`


/*
EXAMPLE:
{
    "geoLevel":"ZIP",
    "aggLevel":"NA",
    "stateCode":"CA",
    "uscdCode":"14",
    "zipCode":"94010",
    "sourceLike":"fback%"
}
*/
const GET_ISSUE_TRENDS_QUERY = gql`
query GetIssueTrendsQuery(
  $geoLevel: GeoLevelType!, 
  $aggLevel: AggLevelType!, 
  $stateCode: String, 
  $uscdCode: String, 
  $ssdCode: String, 
  $zipCode: String,
  $sourceLike: String
) {
  issueTrends(
    geoLevel: $geoLevel, 
    aggLevel: $aggLevel, 
    stateCode: $stateCode, 
    uscdCode: $uscdCode,
    ssdCode: $ssdCode,
    zipCode: $zipCode,
    sourceLike: $sourceLike
   ) {
    issue {
      uuid
      slug
      txt
      level
    },
    YEAR_N,
    WEEK_N,
    ISSUE_FBACK_COUNT,
    ISSUE_FBACK_RANK,
    ISSUE_FBACK_POSITIVE_COUNT,
    ISSUE_FBACK_NEGATIVE_COUNT,
    LEVELS
  }
}
`

const GET_ISSUE_TRENDS_V2_QUERY = gql`
query GetStatementTrendsQuery(
  $timeRange: TimeRangeInputType
  $rollups: [RollupType]
  $filters: FiltersInputType
) {
  issueTrendsV2(
    timeRange: $timeRange
    rollups: $rollups
    filters: $filters
  ) {
    issue {
      uuid
      slug
      txt
      level
    }
    YEAR_N
    WEEK_N
    DAY_N
    ISSUE_FBACK_COUNT
    ISSUE_FBACK_RANK
    ISSUE_FBACK_POSITIVE_COUNT
    ISSUE_FBACK_NEGATIVE_COUNT
    LEVELS
  }
}
`

/*
EXAMPLE:
{
    "geoLevel":"ZIP",
    "aggLevel":"NA",
    "stateCode":"CA",
    "uscdCode":"14",
    "zipCode":"94010",
    "sourceLike":"fback%"
}
*/

/*
const GET_STATEMENT_TRENDS_V2_QUERY = gql`
query GetStatementTrendsV2(
  $range: TimeRangeInputType 
  $rollups: [RollupInputType] 
  $filters: FiltersInputType
) {
  statementTrendsV2(
     range: $range
     rollups: $rollups
) {
}
`
*/

const GET_STATEMENT_TRENDS_V2_QUERY = gql`
query GetStatementTrendsQuery(
  $timeRange: TimeRangeInputType
  $rollups: [RollupType]
  $filters: FiltersInputType
) {
  statementTrendsV2(
    timeRange: $timeRange
    rollups: $rollups
    filters: $filters
  ) {
    issue {
      uuid
      slug
      txt
      level
    }
    statement {
      uuid
      slug
      txt
    }
    YEAR_N
    WEEK_N
    DAY_N
    STATEMENT_FBACK_COUNT
    STATEMENT_FBACK_RANK
    STATEMENT_FBACK_POSITIVE_COUNT
    STATEMENT_FBACK_NEGATIVE_COUNT
    LEVELS
  }
}
`


const GET_STATEMENT_TRENDS_QUERY = gql`
query GetStatementTrendsQuery(
  $geoLevel: GeoLevelType!,
  $aggLevel: AggLevelType!,
  $stateCode: String,
  $uscdCode: String,
  $ssdCode: String,
  $zipCode: String
  $sourceLike: String
) {
  statementTrends(
    geoLevel: $geoLevel
    aggLevel: $aggLevel
    stateCode: $stateCode
    uscdCode: $uscdCode
    ssdCode: $ssdCode
    zipCode: $zipCode
    sourceLike: $sourceLike
  ) {
    issue {
      uuid
      slug
      txt
      level
    }
    statement {
      uuid
      slug
      txt
    }
    YEAR_N
    WEEK_N
    STATEMENT_FBACK_COUNT
    STATEMENT_FBACK_RANK
    STATEMENT_FBACK_POSITIVE_COUNT
    STATEMENT_FBACK_NEGATIVE_COUNT
    LEVELS
  }
}
`
/*
EXAMPLE:
no args for now
*/
const GET_USERS_QUERY = gql`
query GetUsers {
  users {
    uuid,
    name,
    email,
    slug,
    timestamp,
    isActive,
    isVerified,
    geo {
      state {
        name,
        code
      },
      uscd {
        code
      },
      county {
        name
      },
      city {
        name
      }
    }
  }
}
`
// lots of fields are going to be null,
// but keep it the same for consistency betweek
// GET_SUB_GEOS and GET_VALID_GEOS
const GET_SUB_GEOS_QUERY = gql`
query GetSubGeos($filters: FiltersInputType) {
  subGeos(filters: $filters) {
       uscd {
         code
       }
       ssd {
         code
       }
       address {
         state {
           code
         }
         zip {
           code
         }
     }
  }
}
`

const GET_VALID_GEOS_QUERY = gql`
query GetValidGeos($filters: FiltersInputType) {
  validGeos(filters: $filters) {
       slug
       email
       geo {
         address {
           state {
             code
           }
           zip {
             code
           }
         }
       }
  }
}
`

const GET_DRIVES_QUERY = gql`
query GetDrives($filters: FiltersInputType) {
  drives(filters: $filters) {
    timestamp
    uuid
    slug
    txt
    tags
    isLatest
    isActive
    geos {
      address {
        zip {
          code
        }
      }
    }
    postTemplates {
      uuid
      slug
      txt
      tags
    }
    customTexts {
      slug
      txt
    }
  }
}
`

const SAVE_USER_MUTATION = gql`
mutation SaveUserMutation ($user:UserInputType!) {
  saveUser(user: $user)
  {
    timestamp
    uuid
    slug
    geo {
      nation {
        name
        code
      }
      uscd {
        code
      }
      county {
        name
      }
      address {
        uuid
        street
        city {
          name
        }
        state {
          name
          code
        }
        zip {
          code
          plus4
        }
      }
    }
    isLatest
    isActive
  }
} 
`

const COPY_USER_POSTS_MUTATION = gql`
mutation CopyUserPostsMutation ($fromUser:UserInputType!, $toUser:UserInputType!) {
  copyUserPosts(fromUser: $fromUser, toUser: $toUser)
  {
    timestamp
    uuid
    slug
    txt
    issue {
      uuid
      slug
      txt
    }
    user {
      geo {
        nation {
          name
          code
        }
        uscd {
          code
        }
        county {
          name
        }
        address {
          uuid
          street
          city {
            name
          }
          state {
            name
            code
          }
          zip {
            code
            plus4
          }
        }
      }
    }
  }
} 
`


export {
    // VAPOR2
    READ_USER_DATA_QUERY,
    SET_USER_MUTATION,
    WRITE_FBACK_MUTATION,
    WRITE_POSTS_MUTATION,
    GET_ISSUE_TRENDS_QUERY,
    GET_STATEMENT_TRENDS_QUERY,
    GET_USERS_QUERY,
    GET_DRIVES_QUERY,
    SAVE_USER_MUTATION,
    COPY_USER_POSTS_MUTATION,
    GET_SUB_GEOS_QUERY,
    GET_VALID_GEOS_QUERY,
    GET_STATEMENT_TRENDS_V2_QUERY,
    GET_ISSUE_TRENDS_V2_QUERY,    
}


